import * as React from 'react'
import { ReactElement } from 'react'
import FormikField, { FormikSubFieldProps } from './FormikField'
import { Input } from '@fluentui/react-components'
import { InputProps } from '@fluentui/react-input'

export default function FormikInputField<Values>(props: FormikSubFieldProps<InputProps, Values>): ReactElement {
    return <FormikField<InputProps, Values> component={Input} {...props} />
}
